import React from 'react'
import {
    Card, Form,Input,Select,Button,Radio,Row,Col,Space,DatePicker,Upload,
  } from "antd";

  
import PageContainer from "./../../component/PageContainer/PageContainer";



const inputField = {
    width: "400px",
    height: "45px",
    marginBottom: "7px"
  }
  
  const inputField2 = {
    width: "250px",
    height: "45px",
    marginBottom: "7px",
  }

  
  const onFinish = (values) => {
    console.log("Received values of form:", values);
  };





export default function ResetPassword() {
    return (
        <>
            <PageContainer>
            <div>
                  <Form form layout="vertical"  onFinish={onFinish} >
          <Card
            style={{ width: "970px" }}
            title="Reset Password"
            bordered={false}
          >
           
              </Card> 
        </Form>
      </div>
    </PageContainer>
    </>
  );
};